export default {
  setAdverts (state, { adverts }) {
    state.adverts = adverts
  },

  setOngoingBids (state, { adverts }) {
    state.ongoingBids = adverts
  },

  createAdvert (state, { advert }) {
    state.adverts.push(advert)
  },

  updateAdvert (state, { newAdvert }) {
    let advert = state.adverts.find(ad => ad.id === newAdvert.id)
    if (advert) {
      Object.assign(advert, newAdvert)
    }
  },

  updateMinNettoWanted (state, { id, minNettoWanted }) {
    const advert = state.adverts.find(ad => ad.id === id)
    if (advert) {
      advert.minNettoWanted = minNettoWanted
      advert.hasNewOffer = false
    }
  },

  deleteNewOfferFlag (state, { id }) {
    const advert = state.adverts.find(ad => ad.id === id)
    if (advert) {
      advert.hasNewOffer = false
    }
  },

  deleteAdvert (state, { id }) {
    state.adverts = state.adverts.filter(advert => advert.id !== id)
  },

  reset (state) {
    state.adverts = []
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/adverts/mutations.js